<template>
    <div class="c-coupon-input-block">
        <span>キャンペーン用のクーポンコードをお持ちの場合、フォームにコードを入力して下さい。</span>
        <input type="text" class="c-coupon-input-block_input" v-model="input_coupon_code" placeholder="クーポンコードを入力">
        <span class="c-coupon-input-block_alert" v-show="error_coupon_activate">{{ error_coupon_activate }}</span>
        <button type="button" class="c-round-btn is-bg-white is-positive u-w-full u-mt-2" @click="couponActivate">クーポンを追加</button>
        <coupon_modal ref="coupon_activate_modal"
            :show_message_modal="show_message_modal"
        >
        </coupon_modal>
    </div>
</template>

<script>
import coupon_modal from './CouponMessageModal.vue'
import axios from 'axios';

export default {
    components: {
        coupon_modal,
    },
    emits: [
        'activate'
    ],
    data() {
        return {
            input_coupon_code : "",
            error_coupon_activate : "",
            show_message_modal : false,
        }
    },
    created() {
    },
    computed: {},
    methods: {
        couponActivate() {
            this.error_coupon_activate = "";
            axios.post('/api/coupon/activate', {
                'COUPON_CODE': this.input_coupon_code
            }).then(res => {
                this.openModal();
                this.$emit('activate');
            }).catch(error => {
                this.error_coupon_activate = error.response.data.errorMessage;
            });
        },
        openModal: function() {
            this.show_message_modal = true;
        },
    },
}
</script>

<style lang="scss" scoped>
// クーポンコード入力フォームを表示するためのスタイル
.c-coupon-input-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 24px;
    font-size: 12px;
    font-weight: 300;
    line-height: 130%;
    background-color: var(--gj-color-blue-bg);
    margin-bottom: 13px;

    .c-coupon-input-block_input.c-coupon-input-block_input {
        --border: 1px solid var(--gj-border-color);
        width: unset;
        padding: 8px 16px;
        border: var(--border);
        color: var(--gj-color-light-black);
        font-size: 13px;
        background: var(--white, #fff);

        &:focus {
            border-bottom: var(--border);
            box-shadow: none;
        }
    }

    .c-coupon-input-block_alert {
        color: var(--gj-color-red);
        font-size: 10px;
        font-weight: 300;
        line-height: 130%;
    }
}
</style>
